import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


export default ()=>{
  let videos = document.querySelectorAll('.content-block video');

  videos.forEach(function(video) {
    //   console.log(video);
      
      video.play();
    // ScrollTrigger.create({
    //   trigger: video,
    //   onEnter: () => video.play(),
    //   onEnterBack: () => video.play(),
    //   onLeave: () => video.pause(),
    //   onLeaveBack: () => video.pause(),
    // });
  });
}